import { render, staticRenderFns } from "./ChangeServiceCodeModal.vue?vue&type=template&id=88b8f4b8&scoped=true"
import script from "./ChangeServiceCodeModal.vue?vue&type=script&lang=js"
export * from "./ChangeServiceCodeModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeServiceCodeModal.vue?vue&type=style&index=0&id=88b8f4b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b8f4b8",
  null
  
)

export default component.exports